import { useLinks } from './useLinks';
import { LinkRow, type LinkItem } from './LinkRow';
import { Skeleton } from '../../components/Skeleton';
import { Button } from '../../components/Button';

export function LinksList({ scope, showOwner }: { scope: 'mine' | 'all'; showOwner: boolean }) {
  const q = useLinks(scope);

  if (q.isLoading) {
    return (
      <ul className="space-y-3" aria-label="Загрузка ссылок">
        <li><Skeleton className="h-6 w-full" /></li>
        <li><Skeleton className="h-6 w-full" /></li>
        <li><Skeleton className="h-6 w-3/4" /></li>
      </ul>
    );
  }
  if (q.isError) {
    return <p className="text-sm text-[#a4322a]">Не удалось загрузить ссылки.</p>;
  }

  const items: LinkItem[] = (q.data?.pages ?? []).flatMap(
    (p: { items: LinkItem[] }) => p.items,
  );

  if (items.length === 0) {
    return (
      <p className="text-sm text-[var(--color-text-muted)]">Пусто. Создайте первую ссылку.</p>
    );
  }

  return (
    <>
      <ul className="space-y-0">
        {items.map((item) => (
          <LinkRow key={item.id} item={item} showOwner={showOwner} />
        ))}
      </ul>
      {q.hasNextPage && (
        <div className="pt-4 text-center">
          <Button
            variant="secondary"
            onClick={() => void q.fetchNextPage()}
            disabled={q.isFetchingNextPage}
          >
            {q.isFetchingNextPage ? 'Загружаем…' : 'Загрузить ещё'}
          </Button>
        </div>
      )}
    </>
  );
}
